// src/components/top-nav-use-cases-menu.tsx
import type { FC } from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
// import { RouterLink } from 'src/components/router-link';
// import { paths } from 'src/paths';
import PublicIcon from '@mui/icons-material/Public'; // Replace with your actual icons
import ExtensionIcon from '@mui/icons-material/Extension';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

export const TopNavUseCasesMenu: FC = () => {
    const items = [
        {
            title: 'Cross-Border Payments',
            description: 'Quick and cheap remittance',
            // path: '/use-cases/payments', // Update with your actual path
            icon: <PublicIcon sx={{ color: 'primary.main' }} />
        },
        {
            title: 'Gaming',
            description: 'Seamless onboarding',
            // path: '/use-cases/gaming', // Update with your actual path
            icon: <ExtensionIcon sx={{ color: 'primary.main' }} />
        },
        {
            title: 'Wallets and Exchange',
            description: 'Superpower your functionality',
            // path: '/use-cases/wallets', // Update with your actual path
            icon: <AccountBalanceWalletIcon sx={{ color: 'primary.main' }} />
        },
        {
            title: 'Others',
            description: 'Many more use cases',
            // path: '/use-cases/others', // Update with your actual path
            icon: <MoreHorizIcon sx={{ color: 'primary.main' }} />
        }
    ];

    return (
        <Box sx={{
            p: 2
        }}>
            <List disablePadding>
                {items.map((item) => (
                    <ListItem
                        // component={RouterLink}
                        disableGutters
                        // href={item.path}
                        key={item.title}
                        sx={{
                            p: 2,
                            borderRadius: 1,
                            '&:hover': {
                                backgroundColor: 'action.hover'
                            }
                        }}
                    >
                        <ListItemIcon sx={{ color: 'primary.main', minWidth: 40 }}>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography variant="subtitle2"
color="text.primary">
                                    {item.title}
                                </Typography>
                            }
                            secondary={
                                <Typography variant="body2"
color="text.secondary">
                                    {item.description}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};